(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.querySelector('.section-header');

        if (!this.header) return;

        this.headerIsAlwaysSticky =
          this.getAttribute('data-sticky-type') === 'always' ||
          this.getAttribute('data-sticky-type') === 'reduce-logo-size';

        this.headerBounds = {};
        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.preventHide = false;

        this.setHeaderHeight();

        this.mediaQuery = window.matchMedia('(max-width: 990px)');
        this.onMediaChange = this.setHeaderHeight.bind(this);

        if (this.mediaQuery.addEventListener) {
          this.mediaQuery.addEventListener('change', this.onMediaChange);
        } else if (this.mediaQuery.addListener) {
          this.mediaQuery.addListener(this.onMediaChange);
        }

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        this.predictiveSearch = this.querySelector('predictive-search');
        this.onScrollHandler = this.onScroll.bind(this);

        this.hideHeaderOnScrollUp = () => {
          this.preventReveal = true;
        };

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, { passive: true });

        this.createObserver();
      }

      setHeaderHeight() {
        if (!this.header) return;

        document.documentElement.style.setProperty(
          '--header-height',
          `${this.header.offsetHeight}px`
        );
      }

      disconnectedCallback() {
        this.removeEventListener(
          'preventHeaderReveal',
          this.hideHeaderOnScrollUp
        );

        window.removeEventListener('scroll', this.onScrollHandler);

        if (this.mediaQuery && this.mediaQuery.removeEventListener) {
          this.mediaQuery.removeEventListener('change', this.onMediaChange);
        } else if (this.mediaQuery && this.mediaQuery.removeListener) {
          this.mediaQuery.removeListener(this.onMediaChange);
        }

        if (this.observer) {
          this.observer.disconnect();
        }
      }

      createObserver() {
        this.observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });

        this.observer.observe(this.header);
      }

      onScroll() {
        const scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) {
          return;
        }

        const headerBottom =
          typeof this.headerBounds.bottom === 'number'
            ? this.headerBounds.bottom
            : 0;

        if (
          scrollTop > this.currentScrollTop &&
          scrollTop > headerBottom
        ) {
          this.header.classList.add('scrolled-past-header');

          if (this.preventHide) return;

          window.requestAnimationFrame(this.hide.bind(this));
        } else if (
          scrollTop < this.currentScrollTop &&
          scrollTop > headerBottom
        ) {
          this.header.classList.add('scrolled-past-header');

          if (!this.preventReveal) {
            window.requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = window.setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            window.requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= 0) {
          this.header.classList.remove('scrolled-past-header');
          window.requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.headerIsAlwaysSticky) return;

        this.header.classList.add(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky'
        );

        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;

        this.header.classList.add(
          'shopify-section-header-sticky',
          'animate'
        );

        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;

        this.header.classList.remove(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'animate'
        );
      }

      closeMenuDisclosure() {
        this.disclosures =
          this.disclosures ||
          this.header.querySelectorAll('header-menu');

        this.disclosures.forEach((disclosure) => {
          if (typeof disclosure.close === 'function') {
            disclosure.close();
          }
        });
      }

      closeSearchModal() {
        this.searchModal =
          this.searchModal ||
          this.header.querySelector('details-modal');

        if (
          this.searchModal &&
          typeof this.searchModal.close === 'function'
        ) {
          this.searchModal.close(false);
        }
      }
    }

    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
